import type { FormInputType } from '@/components/UI/Form/types'

import { getTutorQuestionnaireQuestion, type TutorQuestionnaire } from '../tutorQuestionnaire'

export default function getTutorQuestionnaireFormInput({
  questionnaire,
  type,
  hide = false,
}: {
  questionnaire: TutorQuestionnaire | null
  type: 'session' | 'series'
  hide?: boolean
}): FormInputType {
  return {
    type: 'textarea',
    name: 'welcome_question',
    size: 6,
    label: 'Welcome Question',
    initialValue: getTutorQuestionnaireQuestion(questionnaire),
    dependencies: {
      keys: [],
      callback() {
        return !hide
      },
    },
    sublabel: `A welcome message and question that students must answer when they register for your ${type}. You don't have to add one, but it might help you understand more about your learners!`,
    placeholder:
      "e.g. Welcome—I'm excited to work with you! What concepts are you having the most trouble with?",
    required: false,
  }
}
